import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { cn } from "@omni/utils/styles";
import { Fragment } from "react";

import { Sections } from "../productComparison.helpers";
import { FeatureKindComponent } from "./FeatureKind/featureKind.component";
import { RowComponent } from "./Row/row.component";

type FeaturesComponentProps = {
    sections: Sections;
    closedSections: Record<string, boolean>;
    products: Array<Product<ProductFieldSet.ProductTile>>;
    width: number;
    toggleSection: (sectionName: string) => void;
};

const FeaturesComponent = ({
    sections,
    closedSections,
    products,
    width,
    toggleSection
}: FeaturesComponentProps) => (
    <>
        {Object.keys(sections).map((sectionName) => (
            <Fragment key={sectionName}>
                <FeatureKindComponent
                    sectionName={sectionName}
                    closed={closedSections[sectionName]}
                    width={width}
                    toggleSection={toggleSection}
                />
                <section className={cn("tw:pt-16")}>
                    {!closedSections?.[sectionName] &&
                        Object.keys(sections[sectionName]).map(
                            (featureName) => (
                                <RowComponent
                                    key={`${sectionName}-${featureName}`}
                                    featureName={featureName}
                                    sectionName={sectionName}
                                    products={products}
                                    sections={sections}
                                />
                            )
                        )}
                </section>
            </Fragment>
        ))}
    </>
);

export { FeaturesComponent };
